<div class="dialog-title">
    <h3> {{data.title}}</h3>
    <span mat-button mat-dialog-close>
        <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
            <path id="close-btn"
                d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                transform="translate(5.82 13.32)" fill="#bbb" />
        </svg>
    </span>



</div>
<mat-dialog-content>

    <ng-container *ngIf="loadingCountries || loadingCategory ; else elseTemplate">
        <app-loading></app-loading>
    </ng-container>
    <ng-template #elseTemplate>
        <div class="register-user">
            <form (ngSubmit)="onRegisterSubmit()" [formGroup]="registerForm">
                <!-- <ng-container *ngIf="adminCanChange">
                    <div class="inputs-form-section">
                        <p class="radioTitle">{{'users.userRole' | translate}}</p>

                        <mat-form-field appearance="outline" class="form-group">
                            <mat-label>{{'users.role' | translate}}</mat-label>
                            <mat-select class="profile-inputs_c-grey-6" formControlName="role">
                                <mat-option *ngFor="let item of roleList" [value]="item.role_code">{{ item.role_name }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="hasError('role', 'required')">
                                {{'validations.required' | translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </ng-container> -->

                <div class="row">
                    <div class="inputs-form-section col-md-6 col-12">
                        <mat-form-field appearance="outline" class="form-group">
                            <mat-label>{{'auth.First Name' | translate}}</mat-label>
                            <input formControlName="firstname" matInput maxlength="20" minlength="3" />
                            <mat-error *ngIf="hasError('firstname', 'required')">
                                {{'validations.required' | translate}}
                            </mat-error>
                            <mat-error *ngIf="hasError('firstname', 'minlength')">
                                {{'validations.minlength' | translate}} 3
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="inputs-form-section col-md-6 col-12">
                        <mat-form-field appearance="outline" class="form-group">
                            <mat-label>{{'auth.Last Name' | translate}}</mat-label>
                            <input formControlName="lastname" matInput maxlength="20" minlength="3" />
                            <mat-error *ngIf="hasError('lastname', 'required')">
                                {{'validations.required' | translate}}
                            </mat-error>
                            <mat-error *ngIf="hasError('lastname', 'minlength')">
                                {{'validations.minlength' | translate}} 3
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="inputs-form-section">
                    <p class="radioTitle">{{'forms.Identification' | translate}}</p>
                    <mat-radio-group class="horizontal_list" formControlName="is_national_number" id="radio"
                        aria-label="Select an option" color="primary">
                        <mat-radio-button [value]="true">{{'forms.National ID' | translate}}</mat-radio-button>
                        <mat-radio-button [value]="false">{{'forms.Resident ID (Iqama)' | translate}}</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="inputs-form-section" [hidden]="registerForm.value.is_national_number!='1'">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'forms.National ID' | translate}}</mat-label>
                        <input type="text" formControlName="national_number" matInput
                            [required]="registerForm.value.is_national_number"
                            [maxlength]="registerForm.value.is_national_number?20:null"
                            [minlength]="registerForm.value.is_national_number?8:null" appOnlynumber />
                        <mat-error *ngIf="hasError('national_number', 'required')">
                            {{'validations.required' | translate}}
                        </mat-error>
                        <mat-error *ngIf="hasError('national_number', 'minlength')">
                            {{'validations.minlength' | translate}} 8
                        </mat-error>
                        <mat-error *ngIf="hasError('national_number', 'pattern')">
                            {{'validations.number' | translate}}
                        </mat-error>
                    </mat-form-field>

                </div>


                <div class="inputs-form-section" [hidden]="registerForm.value.is_national_number == '1'">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'forms.Resident ID (Iqama)' | translate}}</mat-label>
                        <input type="text" formControlName="resident_number" matInput
                            [required]="!registerForm.value.is_national_number"
                            [maxlength]="!registerForm.value.is_national_number?20:null"
                            [minlength]="!registerForm.value.is_national_number?8:null" appOnlynumber />
                        <mat-error *ngIf="hasError('resident_number', 'required')">
                            {{'validations.required' | translate}}
                        </mat-error>
                        <mat-error *ngIf="hasError('resident_number', 'minlength')">
                            {{'validations.minlength' | translate}} 8
                        </mat-error>
                        <mat-error *ngIf="hasError('resident_number', 'pattern')">
                            {{'validations.number' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>


                <div class="inputs-form-section" [hidden]="HideEmailAndPhone">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'auth.email' | translate}}</mat-label>
                        <input formControlName="email" matInput maxlength="50" />
                        <mat-error *ngIf="hasError('email', 'required')">
                            {{'validations.required' | translate}}
                        </mat-error>
                        <mat-error *ngIf="hasError('email', 'pattern')">
                            {{'validations.invalidEmail' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="inputs-form-section teleInput" [hidden]="HideEmailAndPhone">
                    <label for="phone" class="text-start pb-2 w-100">{{'auth.phone' | translate}}</label>
                    <ngx-intl-tel-input [cssClass]="'tel-input'" ariaLabel="phone"
                        customPlaceholder="{{'auth.phone' | translate}}" [enableAutoCountrySelect]="true"
                        [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [maxLength]="20"
                        [numberFormat]="PhoneNumberFormat.International" [phoneValidation]="true" [searchCountryField]="[
                              SearchCountryField.Iso2,
                              SearchCountryField.Name
                            ]" [searchCountryFlag]="true" [searchCountryFlag]="true" [selectFirstCountry]="false"
                        [selectedCountryISO]="CountryISO" [separateDialCode]="separateDialCode" formControlName="phone"
                        name="phone">
                    </ngx-intl-tel-input>
                    <mat-error class="mat-intl-error" *ngIf="registerForm.controls['phone'].invalid &&
                     !hasError('phone', 'required') ">
                        {{'validations.Invalid Phone Format' | translate}}
                    </mat-error>
                    <mat-error
                        *ngIf="hasError('phone', 'required') && (registerForm.controls['phone'].touched ||formSubmitAttempt )">
                        {{'validations.required' | translate}}
                    </mat-error>

                </div>

                <div *ngIf="data.type=='add'" class="inputs-form-section"
                    [ngClass]="{'pb-3': hasError('password', 'pattern')}">
                    <mat-form-field appearance="outline">
                        <mat-label>{{'auth.password' | translate}}</mat-label>
                        <input matInput maxlength="50" minlength="8" placeholder="" [type]="hide ? 'password' : 'text'"
                            formControlName="password" required autocomplete="new-password">
                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' :
                            'visibility'}}</mat-icon>
                        <mat-error *ngIf="hasError('password', 'required')">
                            {{'validations.required' | translate}}
                        </mat-error>
                        <mat-error *ngIf="hasError('password', 'pattern')">
                            {{'validations.password' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="inputs-form-section">
                    <p class="radioTitle">{{'forms.Address' | translate}}</p>

                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'forms.Country' | translate}}</mat-label>

                        <mat-select formControlName="country_id" [required]="data.type=='compelete'"
                            (selectionChange)="onLoadRegion(registerForm.value.country_id)">
                            <mat-option *ngFor="let item of countries" [value]="item.id">
                                {{item.name}}
                            </mat-option>

                        </mat-select>
                        <mat-error *ngIf="hasError('country_id', 'required')">
                            {{'validations.required' | translate}}
                        </mat-error>
                    </mat-form-field>

                </div>
                <div class="inputs-form-section">
                    <mat-form-field appearance="outline" class="form-group" [class.loading]="loadingRegions">
                        <mat-label>{{'forms.Region' | translate}}</mat-label>
                        <mat-select formControlName="region_id" [required]="data.type=='compelete'">
                            <mat-option [value]="item.id" *ngFor="let item of RegionsList">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('region_id', 'required')">
                            {{'validations.required' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <!-- City -->
                <div class="inputs-form-section">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'forms.City' | translate}}</mat-label>
                        <input formControlName="city" matInput maxlength="20" minlength="3"
                            [required]="data.type=='compelete'" />
                        <mat-error *ngIf="hasError('city', 'required')">
                            {{'validations.required' | translate}}
                        </mat-error>
                        <mat-error *ngIf="hasError('city', 'minlength')">
                            {{'validations.minlength' | translate}} 3
                        </mat-error>
                    </mat-form-field>
                </div>
                <!-- street_name -->
                <div class="inputs-form-section">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'forms.Street Address' | translate}}</mat-label>
                        <input formControlName="street" matInput maxlength="20" minlength="3"
                            [required]="data.type=='compelete'" />
                        <mat-error *ngIf="hasError('street', 'required')">
                            {{'validations.required' | translate}}
                        </mat-error>
                        <mat-error *ngIf="hasError('street', 'minlength')">
                            {{'validations.minlength' | translate}} 3
                        </mat-error>
                    </mat-form-field>
                </div>


                <div class="inputs-form-section">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'forms.interests' | translate}}</mat-label>
                        <mat-select formControlName="interests" multiple>
                            <mat-option *ngFor="let item of categoriesList" [value]="item.id">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('interests', 'required')">
                            {{'validations.required' | translate}}
                        </mat-error>
                    </mat-form-field>

                </div>


                <div class="group_btn">
                    <button *ngIf="!loading" mat-button mat-dialog-close class="btnLight_fill" [appLoading]="loading">
                        {{'users.CANCEL' | translate}}
                    </button>
                    <button mat-button class="btn_fill" type="submit" [appLoading]="loading">
                        {{data.buttonText}}
                    </button>


                </div>

            </form>

        </div>
    </ng-template>


</mat-dialog-content>